// ==================================================
// 📊 STATISTIQUES GLOBALES
// ==================================================
// TOTAL : 38 PAYS AFRICAINS

// ==================================================
// 🏘️ COMMUNES D'ABIDJAN (ZONE 1)
// ==================================================
export const COMMUNE_ZONE_MAPPING = {
    'Abobo': 'zone1',
    'Adjamé': 'zone1', 
    'Attécoubé': 'zone1',
    'Cocody': 'zone1',
    'Koumassi': 'zone1',
    'Marcory': 'zone1',
    'Plateau': 'zone1',
    'Port-Bouët': 'zone1',
    'Treichville': 'zone1',
    'Yopougon': 'zone1',
    'Songon': 'zone1',
    'Bingerville': 'zone2',
  };
  
  // ==================================================
  // 🏙️ VILLES DE COTE D'IVOIRE
  // ==================================================
  export const CITY_ZONE_MAPPING = {
    // ZONE 1 - VILLES DU CENTRE (20 villes)
   'Abidjan': 'zone1',
  
  // ZONE 2 - PÉRIPHÉRIE D'ABIDJAN
  'Anyama': 'zone2',
  'Bingerville': 'zone2',
  'Songon': 'zone2',
  'Alépé': 'zone2',
  'Oghlwapo': 'zone2',
  'Dabou': 'zone2',
  'Sikensi': 'zone2',
  'Grand-Lahou': 'zone2',
  'Jacqueville': 'zone2',
  'Aboisso': 'zone2',
  'Ayamé': 'zone2',
  'Bianouan': 'zone2',
  'Maféré': 'zone2',
  'Tiapoum': 'zone2',
  'Adiaké': 'zone2',
  'Assinie-mafia': 'zone2',
  'Etuéboué': 'zone2',
  'Grand-bassam': 'zone2',
  'Bonoua': 'zone2',
  
  // ZONE 3 - GRANDS CENTRES URBAINS
  'Tiassalé': 'zone3',
  'Taabo': 'zone3',
  'Korhogo': 'zone3',
  'Daloa': 'zone3',
  'Agboville': 'zone3',
  'Azaguié': 'zone3',
  'Céchi': 'zone3',
  'Grand morié': 'zone3',
  'Oress-krobou': 'zone3',
  'Rubino': 'zone3',
  'Adzopé': 'zone3',
  'Agou': 'zone3',
  'Afféry': 'zone3',
  'Bécédi-brignan': 'zone3',
  'Akoupé': 'zone3',
  'Assikoi': 'zone3',
  'Yakasse-attobrou': 'zone3',
  'Abengourou': 'zone3',
  'Bouaké': 'zone3',
  'Vavoua': 'zone3',
  'San-Pédro': 'zone3',
  'Daoukro': 'zone3',
  'Assuéfry': 'zone3',
  'Zouan-hounien': 'zone3',
  'Toumodi': 'zone3',
  'Guiglo': 'zone3',
  'Tabou': 'zone3',
  'Dabakala': 'zone3',
  'Katiola': 'zone3',
  'Tafiré': 'zone3',
  'Sakassou': 'zone3',
  'Tomoudi': 'zone3',
  'Didiévi': 'zone3',
  'Djékanou': 'zone3',
  'Tiébissou': 'zone3',
  'Bocanda': 'zone3',
  'Prikro': 'zone3',
  'Bouaflé': 'zone3',
  'Gagnoa': 'zone3',
  'Ouragahio': 'zone3',
  'Oumé': 'zone3',
  'Yamoussoukro': 'zone3',
  'Divo': 'zone3',
  'Guitry': 'zone3',
  'Sassandra': 'zone3',
  
  // ZONE 4 - VILLES MOYENNES
  'Boundiali': 'zone4',
  'Kouto': 'zone4',
  'Ferkessédougou': 'zone4',
  'Kong': 'zone4',
  'Issia': 'zone4',
  'Saïoua': 'zone4',
  'Agnibilékrou': 'zone4',
  'Béoumi': 'zone4',
  'Man': 'zone4',
  'Bondoukou': 'zone4',
  'Dimbokro': 'zone4',
  'Lakota': 'zone4',
  'Duékoué': 'zone4',
  'Bloléquin': 'zone4',
  'Tanda': 'zone4',
  'Grand-Béréby': 'zone4',
  'Méagui': 'zone4',
  'Zuénoula': 'zone4',
  'Mankono': 'zone4',
  'Kani': 'zone4',
  'Séguéla': 'zone4',
  'Odienné': 'zone4',
  'Bouna': 'zone4',
  'Sinfra': 'zone4',
  'Arrah': 'zone4',
  
  // ZONE 5 - ZONES RURALES
  'Dikodougou': 'zone5',
  'Guiembé': 'zone5',
  'Karakoro': 'zone5',
  'Komborodougou': 'zone5',
  'M\'bengué': 'zone5',
  'Napiéolédougou': 'zone5',
  'Niofoin': 'zone5',
  'Tioroniaradougou': 'zone5',
  'Sinématiali': 'zone5',
  'Sirasso': 'zone5',
  'Gbon': 'zone5',
  'Kasséré': 'zone5',
  'Kolia': 'zone5',
  'Diawala': 'zone5',
  'Koumbala': 'zone5',
  'Niellé': 'zone5',
  'Ouangolodougou': 'zone5',
  'Kanakono': 'zone5',
  'Tengréla': 'zone5',
  'Bédiala': 'zone5',
  'Gadouan': 'zone5',
  'Gboguhé': 'zone5',
  'Zaïbo': 'zone5',
  'Zoukougbeu': 'zone5',
  'Boguédia': 'zone5',
  'Iboguhé': 'zone5',
  'Dania': 'zone5',
  'Séitifla': 'zone5',
  'Bettié': 'zone5',
  'Niablé': 'zone5',
  'Diabo': 'zone5',
  'Djebonoua': 'zone5',
  'Brobo': 'zone5',
  'Botro': 'zone5',
  'Languibonou': 'zone5',
  'Bodokro': 'zone5',
  'Ando-kékrénou': 'zone5',
  'Kondrobo': 'zone5',
  'Bassawa': 'zone5',
  'Boniérédougou': 'zone5',
  'Foumbolo': 'zone5',
  'Satama-sokoro': 'zone5',
  'Satama-sokouro': 'zone5',
  'Fronan': 'zone5',
  'Niakaramandougou': 'zone5',
  'Tortiya': 'zone5',
  'Timbé': 'zone5',
  'Facobly': 'zone5',
  'Kouibly': 'zone5',
  'Logoualé': 'zone5',
  'Sangouiné': 'zone5',
  'Sémien': 'zone5',
  'Niadrou': 'zone5',
  'Totrodrou': 'zone5',
  'Bangolo': 'zone5',
  'Diéouzon': 'zone5',
  'Zéo': 'zone5',
  'Zou': 'zone5',
  'Biankouma': 'zone5',
  'Gbonné': 'zone5',
  'Sipilou': 'zone5',
  'Danané': 'zone5',
  'Bin-houyé': 'zone5',
  'Mahapleu': 'zone5',
  'Fresco': 'zone5',
  'Hiré': 'zone5',
  'Yocoboué': 'zone5',
  'Niambézaria': 'zone5',
  'Zikisso': 'zone5',
  'Bayota': 'zone5',
  'Gnagbodougnoa': 'zone5',
  'Guibéroua': 'zone5',
  'Diégonéfla': 'zone5',
  'Attiégouakro': 'zone5',
  'Tié-N\'diékro': 'zone5',
  'Kpouèbo': 'zone5',
  'Kokoumbo': 'zone5',
  'Bagohouo': 'zone5',
  'Gbapleu': 'zone5',
  'Guéhiébly': 'zone5',
  'Guézon': 'zone5',
  'Taï': 'zone5',
  'Toulépleu': 'zone5',
  'Bakoubly': 'zone5',
  'Péhé': 'zone5',
  'Tiobly': 'zone5',
  'Gouméré': 'zone5',
  'Tabagne': 'zone5',
  'Taoudi': 'zone5',
  'Sorobango': 'zone5',
  'Sapli': 'zone5',
  'Sandégué': 'zone5',
  'Doropo': 'zone5',
  'Nassian': 'zone5',
  'Tehini': 'zone5',
  'Kouassi-datèkro': 'zone5',
  'Transua': 'zone5',
  'Tankessé': 'zone5',
  'Booko': 'zone5',
  'Borotou': 'zone5',
  'Guintéguéla': 'zone5',
  'Koonan': 'zone5',
  'Koro': 'zone5',
  'Ouaninou': 'zone5',
  'Touba': 'zone5',
  'Foungbesso': 'zone5',
  'Guéyo': 'zone5',
  'Sago': 'zone5',
  'Buyo': 'zone5',
  'Grand-Zattry': 'zone5',
  'Okrouyo': 'zone5',
  'Soubré': 'zone5',
  'Grabo': 'zone5',
  'Anoumaba': 'zone5',
  'Bongouanou': 'zone5',
  'M\'batto': 'zone5',
  'Tiémélékro': 'zone5',
  'Ettrokro': 'zone5',
  'Kouassi-kouassikro': 'zone5',
  'Ouellé': 'zone5',
  'M\'bahiakro': 'zone5',
  'Bonguéra': 'zone5',
  'Koffi-amonkro': 'zone5',
  'Bonon': 'zone5',
  'Kouétinfla': 'zone5',
  'Bazré': 'zone5',
  'Konéfla': 'zone5',
  'Gohitafla': 'zone5',
  'Dianra': 'zone5',
  'Kongasso': 'zone5',
  'Kounahiri': 'zone5',
  'Marandallah': 'zone5',
  'Sarhala': 'zone5',
  'Tiéningboué': 'zone5',
  'Djibrosso': 'zone5',
  'Dualla': 'zone5',
  'Massala': 'zone5',
  'Morondo': 'zone5',
  'Sifié': 'zone5',
  'Worofla': 'zone5',
  'Bako': 'zone5',
  'Dioulatiédougou': 'zone5',
  'Gbeleban': 'zone5',
  'Goulia': 'zone5',
  'Kaniasso': 'zone5',
  'Madinani': 'zone5',
  'Minignan': 'zone5',
  'Samatiguila': 'zone5',
  'Séguélon': 'zone5',
  'Seydougou': 'zone5',
  'Tiémé': 'zone5',
  'Tienko': 'zone5'
  };
  
  // ==================================================
  // 🌍 PAYS DE LA SOUS-RÉGION (38 PAYS)
  // ==================================================
  export const COUNTRY_ZONE_MAPPING = {
    // ZONE 1 - PAYS FRONTALIERS PROCHEs (5 pays)
    'Ghana': 'zone1',
    'Burkina Faso': 'zone1',
    'Mali': 'zone1',
    'Guinée': 'zone1',
    'Liberia': 'zone1',
    
    // ZONE 2 - PAYS VOISINS DIRECTS (5 pays)
    'Togo': 'zone2',
    'Bénin': 'zone2',
    'Niger': 'zone2',
    'Sierra Leone': 'zone2',
    'Guinée-Bissau': 'zone2',
    
    // ZONE 3 - AFRIQUE DE L'OUEST (5 pays)
    'Nigeria': 'zone3',
    'Sénégal': 'zone3',
    'Gambie': 'zone3',
    'Cap-Vert': 'zone3',
    'Côte d\'Ivoire': 'zone3',
    
    // ZONE 4 - AFRIQUE CENTRALE (8 pays)
    'Cameroun': 'zone4',
    'Gabon': 'zone4',
    'Congo': 'zone4',
    'République Démocratique du Congo': 'zone4',
    'République Centrafricaine': 'zone4',
    'Tchad': 'zone4',
    'Guinée Équatoriale': 'zone4',
    'São Tomé-et-Príncipe': 'zone4',
    
    // ZONE 5 - AUTRES PAYS AFRICAINS (15 pays)
    'Maroc': 'zone5',
    'Algérie': 'zone5',
    'Tunisie': 'zone5',
    'Égypte': 'zone5',
    
    'Libye': 'zone5',
    'Mauritanie': 'zone5',
    'Soudan': 'zone5',
    'Éthiopie': 'zone5',
    'Kenya': 'zone5',
    'Tanzanie': 'zone5',
    'Afrique du Sud': 'zone5',
    'Angola': 'zone5',
    'Namibie': 'zone5',
  };
  
  // ==================================================
  // 🏙️ VILLES DES PAYS AFRICAINS (38 pays × 10 villes)
  // ==================================================
  export const COUNTRY_CITY_ZONE_MAPPING = {
    // ZONE 1 - PAYS FRONTALIERS PROCHEs (5 pays)
    'Ghana': {
      'Accra': 'zone1', 'Kumasi': 'zone1', 'Tamale': 'zone1', 'Takoradi': 'zone1', 'Cape Coast': 'zone1',
      'Tema': 'zone1', 'Sekondi': 'zone1', 'Obuasi': 'zone1', 'Wa': 'zone1', 'Ho': 'zone1'
    },
    'Burkina Faso': {
      'Ouagadougou': 'zone1', 'Bobo-Dioulasso': 'zone1', 'Koudougou': 'zone1', 'Banfora': 'zone1', 'Ouahigouya': 'zone1',
      'Dédougou': 'zone1', 'Kaya': 'zone1', 'Tenkodogo': 'zone1', 'Fada N\'Gourma': 'zone1', 'Dori': 'zone1'
    },
    'Mali': {
      'Bamako': 'zone1', 'Sikasso': 'zone1', 'Mopti': 'zone1', 'Ségou': 'zone1', 'Gao': 'zone1',
      'Kayes': 'zone1', 'Koutiala': 'zone1', 'San': 'zone1', 'Kidal': 'zone1', 'Tombouctou': 'zone1'
    },
    'Guinée': {
      'Conakry': 'zone1', 'Kankan': 'zone1', 'Kindia': 'zone1', 'Nzérékoré': 'zone1', 'Labé': 'zone1',
      'Mamou': 'zone1', 'Faranah': 'zone1', 'Boké': 'zone1', 'Kissidougou': 'zone1', 'Macenta': 'zone1'
    },
    'Liberia': {
      'Monrovia': 'zone1', 'Gbarnga': 'zone1', 'Buchanan': 'zone1', 'Kakata': 'zone1', 'Voinjama': 'zone1',
      'Harper': 'zone1', 'Robertsport': 'zone1', 'Greenville': 'zone1', 'Zwedru': 'zone1', 'Sanniquellie': 'zone1'
    },
    
    // ZONE 2 - PAYS VOISINS DIRECTS (5 pays)
    'Togo': {
      'Lomé': 'zone2', 'Sokodé': 'zone2', 'Kara': 'zone2', 'Atakpamé': 'zone2', 'Palimé': 'zone2',
      'Bassar': 'zone2', 'Tsévié': 'zone2', 'Aného': 'zone2', 'Mango': 'zone2', 'Dapaong': 'zone2'
    },
    'Bénin': {
      'Cotonou': 'zone2', 'Porto-Novo': 'zone2', 'Parakou': 'zone2', 'Djougou': 'zone2', 'Abomey': 'zone2',
      'Natitingou': 'zone2', 'Lokossa': 'zone2', 'Ouidah': 'zone2', 'Kandi': 'zone2', 'Malanville': 'zone2'
    },
    'Niger': {
      'Niamey': 'zone2', 'Zinder': 'zone2', 'Maradi': 'zone2', 'Agadez': 'zone2', 'Tahoua': 'zone2',
      'Arlit': 'zone2', 'Dosso': 'zone2', 'Birni-Nkonni': 'zone2', 'Diffa': 'zone2', 'Gaya': 'zone2'
    },
    'Sierra Leone': {
      'Freetown': 'zone2', 'Bo': 'zone2', 'Kenema': 'zone2', 'Makeni': 'zone2', 'Koidu': 'zone2',
      'Port Loko': 'zone2', 'Lunsar': 'zone2', 'Waterloo': 'zone2', 'Kabala': 'zone2', 'Segbwema': 'zone2'
    },
    'Guinée-Bissau': {
      'Bissau': 'zone2', 'Bafatá': 'zone2', 'Gabú': 'zone2', 'Bissorã': 'zone2', 'Bolama': 'zone2',
      'Cacheu': 'zone2', 'Bubaque': 'zone2', 'Catió': 'zone2', 'Mansôa': 'zone2', 'Canchungo': 'zone2'
    },
    
    // ZONE 3 - AFRIQUE DE L'OUEST (5 pays)
        // ZONE 3 - AFRIQUE DE L'OUEST (5 pays)
  'Côte d\'Ivoire': {
    // ZONE 1 - COMMUNES D'ABIDJAN
    'Abidjan': 'zone1',
    
    // ZONE 2 - PÉRIPHÉRIE D'ABIDJAN
    'Anyama': 'zone2',
    'Bingerville': 'zone2',
    'Songon': 'zone2',
    'Alépé': 'zone2',
    'Oghlwapo': 'zone2',
    'Dabou': 'zone2',
    'Sikensi': 'zone2',
    'Grand-Lahou': 'zone2',
    'Jacqueville': 'zone2',
    'Aboisso': 'zone2',
    'Ayamé': 'zone2',
    'Bianouan': 'zone2',
    'Maféré': 'zone2',
    'Tiapoum': 'zone2',
    'Adiaké': 'zone2',
    'Assinie-mafia': 'zone2',
    'Etuéboué': 'zone2',
    'Grand-bassam': 'zone2',
    'Bonoua': 'zone2',
    
    // ZONE 3 - GRANDS CENTRES URBAINS
    'Tiassalé': 'zone3',
    'Taabo': 'zone3',
    'Korhogo': 'zone3',
    'Daloa': 'zone3',
    'Agboville': 'zone3',
    'Azaguié': 'zone3',
    'Céchi': 'zone3',
    'Grand morié': 'zone3',
    'Oress-krobou': 'zone3',
    'Rubino': 'zone3',
    'Adzopé': 'zone3',
    'Agou': 'zone3',
    'Afféry': 'zone3',
    'Bécédi-brignan': 'zone3',
    'Akoupé': 'zone3',
    'Assikoi': 'zone3',
    'Yakasse-attobrou': 'zone3',
    'Abengourou': 'zone3',
    'Bouaké': 'zone3',
    'Vavoua': 'zone3',
    'San-Pédro': 'zone3',
    'Daoukro': 'zone3',
    'Assuéfry': 'zone3',
    'Zouan-hounien': 'zone3',
    'Toumodi': 'zone3',
    'Guiglo': 'zone3',
    'Tabou': 'zone3',
    'Dabakala': 'zone3',
    'Katiola': 'zone3',
    'Tafiré': 'zone3',
    'Sakassou': 'zone3',
    'Tomoudi': 'zone3',
    'Didiévi': 'zone3',
    'Djékanou': 'zone3',
    'Tiébissou': 'zone3',
    'Bocanda': 'zone3',
    'Prikro': 'zone3',
    'Bouaflé': 'zone3',
    'Gagnoa': 'zone3',
    'Ouragahio': 'zone3',
    'Oumé': 'zone3',
    'Yamoussoukro': 'zone3',
    'Divo': 'zone3',
    'Guitry': 'zone3',
    'Sassandra': 'zone3',
    
    // ZONE 4 - VILLES MOYENNES
    'Boundiali': 'zone4',
    'Kouto': 'zone4',
    'Ferkessédougou': 'zone4',
    'Kong': 'zone4',
    'Issia': 'zone4',
    'Saïoua': 'zone4',
    'Agnibilékrou': 'zone4',
    'Béoumi': 'zone4',
    'Man': 'zone4',
    'Bondoukou': 'zone4',
    'Dimbokro': 'zone4',
    'Lakota': 'zone4',
    'Duékoué': 'zone4',
    'Bloléquin': 'zone4',
    'Tanda': 'zone4',
    'Grand-Béréby': 'zone4',
    'Méagui': 'zone4',
    'Zuénoula': 'zone4',
    'Mankono': 'zone4',
    'Kani': 'zone4',
    'Séguéla': 'zone4',
    'Odienné': 'zone4',
    'Bouna': 'zone4',
    'Sinfra': 'zone4',
    'Arrah': 'zone4',
    
    // ZONE 5 - ZONES RURALES
    'Dikodougou': 'zone5',
    'Guiembé': 'zone5',
    'Karakoro': 'zone5',
    'Komborodougou': 'zone5',
    'M\'bengué': 'zone5',
    'Napiéolédougou': 'zone5',
    'Niofoin': 'zone5',
    'Tioroniaradougou': 'zone5',
    'Sinématiali': 'zone5',
    'Sirasso': 'zone5',
    'Gbon': 'zone5',
    'Kasséré': 'zone5',
    'Kolia': 'zone5',
    'Diawala': 'zone5',
    'Koumbala': 'zone5',
    'Niellé': 'zone5',
    'Ouangolodougou': 'zone5',
    'Kanakono': 'zone5',
    'Tengréla': 'zone5',
    'Bédiala': 'zone5',
    'Gadouan': 'zone5',
    'Gboguhé': 'zone5',
    'Zaïbo': 'zone5',
    'Zoukougbeu': 'zone5',
    'Boguédia': 'zone5',
    'Iboguhé': 'zone5',
    'Dania': 'zone5',
    'Séitifla': 'zone5',
    'Bettié': 'zone5',
    'Niablé': 'zone5',
    'Diabo': 'zone5',
    'Djebonoua': 'zone5',
    'Brobo': 'zone5',
    'Botro': 'zone5',
    'Languibonou': 'zone5',
    'Bodokro': 'zone5',
    'Ando-kékrénou': 'zone5',
    'Kondrobo': 'zone5',
    'Bassawa': 'zone5',
    'Boniérédougou': 'zone5',
    'Foumbolo': 'zone5',
    'Satama-sokoro': 'zone5',
    'Satama-sokouro': 'zone5',
    'Fronan': 'zone5',
    'Niakaramandougou': 'zone5',
    'Tortiya': 'zone5',
    'Timbé': 'zone5',
    'Facobly': 'zone5',
    'Kouibly': 'zone5',
    'Logoualé': 'zone5',
    'Sangouiné': 'zone5',
    'Sémien': 'zone5',
    'Niadrou': 'zone5',
    'Totrodrou': 'zone5',
    'Bangolo': 'zone5',
    'Diéouzon': 'zone5',
    'Zéo': 'zone5',
    'Zou': 'zone5',
    'Biankouma': 'zone5',
    'Gbonné': 'zone5',
    'Sipilou': 'zone5',
    'Danané': 'zone5',
    'Bin-houyé': 'zone5',
    'Mahapleu': 'zone5',
    'Fresco': 'zone5',
    'Hiré': 'zone5',
    'Yocoboué': 'zone5',
    'Niambézaria': 'zone5',
    'Zikisso': 'zone5',
    'Bayota': 'zone5',
    'Gnagbodougnoa': 'zone5',
    'Guibéroua': 'zone5',
    'Diégonéfla': 'zone5',
    'Attiégouakro': 'zone5',
    'Tié-N\'diékro': 'zone5',
    'Kpouèbo': 'zone5',
    'Kokoumbo': 'zone5',
    'Bagohouo': 'zone5',
    'Gbapleu': 'zone5',
    'Guéhiébly': 'zone5',
    'Guézon': 'zone5',
    'Taï': 'zone5',
    'Toulépleu': 'zone5',
    'Bakoubly': 'zone5',
    'Péhé': 'zone5',
    'Tiobly': 'zone5',
    'Gouméré': 'zone5',
    'Tabagne': 'zone5',
    'Taoudi': 'zone5',
    'Sorobango': 'zone5',
    'Sapli': 'zone5',
    'Sandégué': 'zone5',
    'Doropo': 'zone5',
    'Nassian': 'zone5',
    'Tehini': 'zone5',
    'Kouassi-datèkro': 'zone5',
    'Transua': 'zone5',
    'Tankessé': 'zone5',
    'Booko': 'zone5',
    'Borotou': 'zone5',
    'Guintéguéla': 'zone5',
    'Koonan': 'zone5',
    'Koro': 'zone5',
    'Ouaninou': 'zone5',
    'Touba': 'zone5',
    'Foungbesso': 'zone5',
    'Guéyo': 'zone5',
    'Sago': 'zone5',
    'Buyo': 'zone5',
    'Grand-Zattry': 'zone5',
    'Okrouyo': 'zone5',
    'Soubré': 'zone5',
    'Grabo': 'zone5',
    'Anoumaba': 'zone5',
    'Bongouanou': 'zone5',
    'M\'batto': 'zone5',
    'Tiémélékro': 'zone5',
    'Ettrokro': 'zone5',
    'Kouassi-kouassikro': 'zone5',
    'Ouellé': 'zone5',
    'M\'bahiakro': 'zone5',
    'Bonguéra': 'zone5',
    'Koffi-amonkro': 'zone5',
    'Bonon': 'zone5',
    'Kouétinfla': 'zone5',
    'Bazré': 'zone5',
    'Konéfla': 'zone5',
    'Gohitafla': 'zone5',
    'Dianra': 'zone5',
    'Kongasso': 'zone5',
    'Kounahiri': 'zone5',
    'Marandallah': 'zone5',
    'Sarhala': 'zone5',
    'Tiéningboué': 'zone5',
    'Djibrosso': 'zone5',
    'Dualla': 'zone5',
    'Massala': 'zone5',
    'Morondo': 'zone5',
    'Sifié': 'zone5',
    'Worofla': 'zone5',
    'Bako': 'zone5',
    'Dioulatiédougou': 'zone5',
    'Gbeleban': 'zone5',
    'Goulia': 'zone5',
    'Kaniasso': 'zone5',
    'Madinani': 'zone5',
    'Minignan': 'zone5',
    'Samatiguila': 'zone5',
    'Séguélon': 'zone5',
    'Seydougou': 'zone5',
    'Tiémé': 'zone5',
    'Tienko': 'zone5'
  },
    'Nigeria': {
      'Lagos': 'zone3', 'Abuja': 'zone3', 'Kano': 'zone3', 'Ibadan': 'zone3', 'Port Harcourt': 'zone3',
      'Benin City': 'zone3', 'Kaduna': 'zone3', 'Maiduguri': 'zone3', 'Enugu': 'zone3', 'Aba': 'zone3'
    },
    'Sénégal': {
      'Dakar': 'zone3', 'Touba': 'zone3', 'Thiès': 'zone3', 'Kaolack': 'zone3', 'Mbour': 'zone3',
      'Saint-Louis': 'zone3', 'Rufisque': 'zone3', 'Ziguinchor': 'zone3', 'Diourbel': 'zone3', 'Tambacounda': 'zone3'
    },
    'Gambie': {
      'Banjul': 'zone3', 'Serekunda': 'zone3', 'Brikama': 'zone3', 'Bakau': 'zone3', 'Farafenni': 'zone3',
      'Lamin': 'zone3', 'Sukuta': 'zone3', 'Basse Santa Su': 'zone3', 'Gunjur': 'zone3', 'Soma': 'zone3'
    },
    'Cap-Vert': {
      'Praia': 'zone3', 'Mindelo': 'zone3', 'Santa Maria': 'zone3', 'Pedra Badejo': 'zone3', 'São Filipe': 'zone3',
      'Assomada': 'zone3', 'Tarrafal': 'zone3', 'Porto Novo': 'zone3', 'Calheta': 'zone3', 'Picos': 'zone3'
    },
    
    // ZONE 4 - AFRIQUE CENTRALE (8 pays)
    'Cameroun': {
      'Yaoundé': 'zone4', 'Douala': 'zone4', 'Garoua': 'zone4', 'Bamenda': 'zone4', 'Maroua': 'zone4',
      'Bafoussam': 'zone4', 'Ngaoundéré': 'zone4', 'Kumba': 'zone4', 'Buéa': 'zone4', 'Foumban': 'zone4'
    },
    'Gabon': {
      'Libreville': 'zone4', 'Port-Gentil': 'zone4', 'Franceville': 'zone4', 'Oyem': 'zone4', 'Moanda': 'zone4',
      'Mouila': 'zone4', 'Lambaréné': 'zone4', 'Tchibanga': 'zone4', 'Koulamoutou': 'zone4', 'Makokou': 'zone4'
    },
    'Congo': {
      'Brazzaville': 'zone4', 'Pointe-Noire': 'zone4', 'Dolisie': 'zone4', 'Nkayi': 'zone4', 'Impfondo': 'zone4',
      'Ouesso': 'zone4', 'Owando': 'zone4', 'Loandjili': 'zone4', 'Gamboma': 'zone4', 'Madingou': 'zone4'
    },
    'République Démocratique du Congo': {
      'Kinshasa': 'zone4', 'Lubumbashi': 'zone4', 'Mbuji-Mayi': 'zone4', 'Kananga': 'zone4', 'Kisangani': 'zone4',
      'Bukavu': 'zone4', 'Goma': 'zone4', 'Kolwezi': 'zone4', 'Matadi': 'zone4', 'Mbandaka': 'zone4'
    },
    'République Centrafricaine': {
      'Bangui': 'zone4', 'Bimbo': 'zone4', 'Berbérati': 'zone4', 'Carnot': 'zone4', 'Bambari': 'zone4',
      'Bouar': 'zone4', 'Bossangoa': 'zone4', 'Bria': 'zone4', 'Kaga-Bandoro': 'zone4', 'Nola': 'zone4'
    },
    'Tchad': {
      'N\'Djamena': 'zone4', 'Moundou': 'zone4', 'Sarh': 'zone4', 'Abéché': 'zone4', 'Kélo': 'zone4',
      'Koumra': 'zone4', 'Pala': 'zone4', 'Am Timan': 'zone4', 'Bongor': 'zone4', 'Mongo': 'zone4'
    },
    'Guinée Équatoriale': {
      'Malabo': 'zone4', 'Bata': 'zone4', 'Ebebiyín': 'zone4', 'Aconibe': 'zone4', 'Anisoc': 'zone4',
      'Luba': 'zone4', 'Evinayong': 'zone4', 'Mongomo': 'zone4', 'Mikomeseng': 'zone4', 'Rebola': 'zone4'
    },
    'São Tomé-et-Príncipe': {
      'São Tomé': 'zone4', 'Santo António': 'zone4', 'Neves': 'zone4', 'Santana': 'zone4', 'Trindade': 'zone4',
      'Guadalupe': 'zone4', 'Santa Cruz': 'zone4', 'Pantufo': 'zone4', 'São João dos Angolares': 'zone4', 'São José': 'zone4'
    },
    
    // ZONE 5 - AUTRES PAYS AFRICAINS (15 pays)
    'Maroc': {
      'Casablanca': 'zone5', 'Rabat': 'zone5', 'Fès': 'zone5', 'Marrakech': 'zone5', 'Tanger': 'zone5',
      'Meknès': 'zone5', 'Agadir': 'zone5', 'Oujda': 'zone5', 'Kénitra': 'zone5', 'Tétouan': 'zone5'
    },
    'Algérie': {
      'Alger': 'zone5', 'Oran': 'zone5', 'Constantine': 'zone5', 'Annaba': 'zone5', 'Blida': 'zone5',
      'Batna': 'zone5', 'Djelfa': 'zone5', 'Sétif': 'zone5', 'Sidi Bel Abbès': 'zone5', 'Biskra': 'zone5'
    },
    'Tunisie': {
      'Tunis': 'zone5', 'Sfax': 'zone5', 'Sousse': 'zone5', 'Ettadhamen': 'zone5', 'Kairouan': 'zone5',
      'Gabès': 'zone5', 'Bizerte': 'zone5', 'Ariana': 'zone5', 'Gafsa': 'zone5', 'La Marsa': 'zone5'
    },
    'Égypte': {
      'Le Caire': 'zone5', 'Alexandrie': 'zone5', 'Gizeh': 'zone5', 'Shubra El-Kheima': 'zone5', 'Port-Saïd': 'zone5',
      'Suez': 'zone5', 'Louxor': 'zone5', 'Mansourah': 'zone5', 'Assiout': 'zone5', 'Ismaïlia': 'zone5'
    },
    'Afrique du Sud': {
      'Johannesburg': 'zone5', 'Le Cap': 'zone5', 'Durban': 'zone5', 'Pretoria': 'zone5', 'Port Elizabeth': 'zone5',
      'Soweto': 'zone5', 'Pietermaritzburg': 'zone5', 'Benoni': 'zone5', 'Tembisa': 'zone5', 'East London': 'zone5'
    },
    'Libye': {
      'Tripoli': 'zone5', 'Benghazi': 'zone5', 'Misrata': 'zone5', 'Tobrouk': 'zone5', 'Syrte': 'zone5',
      'Zawiya': 'zone5', 'Ajdabiya': 'zone5', 'Derna': 'zone5', 'Sabah': 'zone5', 'Zintan': 'zone5'
    },
    'Mauritanie': {
      'Nouakchott': 'zone5', 'Nouadhibou': 'zone5', 'Rosso': 'zone5', 'Kaédi': 'zone5', 'Zouérat': 'zone5',
      'Atar': 'zone5', 'Kiffa': 'zone5', 'Sélibaby': 'zone5', 'Néma': 'zone5', 'Tidjikja': 'zone5'
    },
    'Soudan': {
      'Khartoum': 'zone5', 'Omdurman': 'zone5', 'Port-Soudan': 'zone5', 'Nyala': 'zone5', 'El-Obeid': 'zone5',
      'Kassala': 'zone5', 'Gedaref': 'zone5', 'Kosti': 'zone5', 'Wad Madani': 'zone5', 'Atbara': 'zone5'
    },
    'Éthiopie': {
      'Addis-Abeba': 'zone5', 'Dire Dawa': 'zone5', 'Mekele': 'zone5', 'Gondar': 'zone5', 'Bahir Dar': 'zone5',
      'Awasa': 'zone5', 'Dessie': 'zone5', 'Jimma': 'zone5', 'Jijiga': 'zone5', 'Shashamane': 'zone5'
    },
    'Kenya': {
      'Nairobi': 'zone5', 'Mombasa': 'zone5', 'Kisumu': 'zone5', 'Nakuru': 'zone5', 'Eldoret': 'zone5',
      'Ruiru': 'zone5', 'Kikuyu': 'zone5', 'Kangundo-Tala': 'zone5', 'Malindi': 'zone5', 'Naivasha': 'zone5'
    },
    'Tanzanie': {
      'Dar es Salaam': 'zone5', 'Dodoma': 'zone5', 'Mwanza': 'zone5', 'Arusha': 'zone5', 'Zanzibar': 'zone5',
      'Mbeya': 'zone5', 'Morogoro': 'zone5', 'Tanga': 'zone5', 'Kigoma': 'zone5', 'Moshi': 'zone5'
    },
    'Angola': {
      'Luanda': 'zone5', 'Huambo': 'zone5', 'Lobito': 'zone5', 'Benguela': 'zone5', 'Kuito': 'zone5',
      'Lubango': 'zone5', 'Malanje': 'zone5', 'Namibe': 'zone5', 'Soyo': 'zone5', 'Cabinda': 'zone5'
    },
    'Namibie': {
      'Windhoek': 'zone5', 'Walvis Bay': 'zone5', 'Swakopmund': 'zone5', 'Rundu': 'zone5', 'Oshakati': 'zone5',
      'Rehoboth': 'zone5', 'Katima Mulilo': 'zone5', 'Otjiwarongo': 'zone5', 'Ondangwa': 'zone5', 'Okahandja': 'zone5'
    }
  };
  
  // ==================================================
  // 🎯 FONCTIONS UTILITAIRES
  // ==================================================
  export const getZone = (localite, pays = null) => {
    if (pays && COUNTRY_CITY_ZONE_MAPPING[pays]) {
      return COUNTRY_CITY_ZONE_MAPPING[pays][localite] || 'zone5';
    }
    return COMMUNE_ZONE_MAPPING[localite] || CITY_ZONE_MAPPING[localite] || 'zone5';
  };
  
  export const getCitiesByCountry = (pays) => {
    return COUNTRY_CITY_ZONE_MAPPING[pays] || {};
  };
  
  // ==================================================
  // 📈 STATISTIQUES DÉTAILLÉES
  // ==================================================
  export const STATS = {
    totalPays: 38,
    repartitionZones: {
      zone1: 5,   // Pays frontaliers
      zone2: 5,   // Pays voisins directs  
      zone3: 5,   // Afrique de l'Ouest (incluant CI)
      zone4: 8,   // Afrique centrale
      zone5: 15   // Autres pays africains
    },
    totalVillesCI: Object.keys(CITY_ZONE_MAPPING).length, // 58 villes
    totalCommunesAbidjan: Object.keys(COMMUNE_ZONE_MAPPING).length, // 12 communes
    totalVillesAfrique: 56 + 370 // 56 villes CI + 370 villes autres pays (37 × 10)
  };